<div class="channel-product-mapping__wrapper">
  <div class="flex justify-end mb-4 gap-2 grow">
    <button class="lum-button" (click)="onOpenSyncProductsModal()">
      <lum-ui-icon
        icon="programming-cloud-download"
        color="#ffffff"
        width="14"
        height="14"
        class="mr-2"
      ></lum-ui-icon>
      Sync Products
    </button>

    <button
      class="lum-button"
      [disabled]="downloadingState"
      (click)="onDownloadChannelProductMapping()"
    >
      <lum-ui-icon
        icon="download-button"
        color="#ffffff"
        width="14"
        height="14"
        class="mr-2"
      ></lum-ui-icon>
      Download Product Mapping
    </button>
  </div>
  <!-- <ag-grid-angular
    class="ag-theme-alpine ag-theme-lum"
    style="width: 100%"
    [columnDefs]="columnDefs"
    [gridOptions]="girdOptions"
    [rowSelection]="'multiple'"
    [suppressHorizontalScroll]="false"
    (selectionChanged)="onSelectionChanged()"
    (gridReady)="onGridReady($event)"
  >
  </ag-grid-angular> -->

  <ag-grid-angular
    class="ag-theme-alpine ag-theme-lum"
    style="width: 100%"
    [columnDefs]="columnDefs"
    [gridOptions]="gridOptions"
    (gridReady)="onGridReady($event)"
  ></ag-grid-angular>
</div>
